"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetch = _interopRequireDefault(require("./fetch"));
var _method = _interopRequireDefault(require("../utils/method"));
var Methods = new _method.default();
var LOGE_URL_GET = 'https://lego.zhuanzhuan.com/page/mark';
var LOGE_URL_POST = 'https://lego.zhuanzhuan.com/page/mark-p';
var ERROR = {
  NO_URL: 401,
  IMG_ON: 400,
  IMG_CATCH: 402,
  BEACON_FALSE: 403,
  XHR_ON: 500,
  RESPONSE: 501,
  TIMEOUT: 505
};
var isSupportBeacon = function isSupportBeacon() {
  var os = Methods.getOS().toLowerCase();
  var version = parseInt(Methods.getOsVersion().split('.')[0], 10);
  if (typeof navigator !== 'undefined' && navigator && navigator.sendBeacon && (os === 'ios' ? version >= 13 : true)) {
    return true;
  } else {
    return false;
  }
};
var encodePayload = function encodePayload(obj) {
  obj.backup = JSON.stringify(obj.backup).replace(/\%/g, '%25');
  obj.backup = encodeURIComponent(obj.backup);
  var string = '';
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      string += "".concat(p, "=").concat(obj[p], "&");
    }
  }
  string = string.slice(0, -1);
  return string;
};
var sendByImg = function sendByImg(url, data, success, fail) {
  try {
    var str = encodePayload(data);
    var img = new Image(1, 1);
    img.onload = function () {
      img = null;
      success && success();
    };
    img.onerror = function () {
      img = null;
      fail && fail(url, data, ERROR.IMG_ON);
    };
    img.src = "".concat(url, "?").concat(str);
  } catch (e) {
    fail && fail(url, data, ERROR.IMG_CATCH, e.message);
  }
};
var request = function request(data, timeout, withCredentials, success, fail, sendBeacon, encryption) {
  try {
    var UA = typeof window === 'undefined' ? '' : window.navigator.userAgent;
    var browserName = typeof window === 'undefined' ? '' : window.navigator.appName;
    var isIE89 = browserName.indexOf('Microsoft Internet Explorer') !== -1 && (UA.indexOf('MSIE 8.0') !== -1 || UA.indexOf('MSIE 9.0') !== -1);
    if (isIE89) {
      sendByImg(LOGE_URL_GET, data, success, fail);
      return;
    } else {
      if (sendBeacon) {
        if (isSupportBeacon()) {
          var status = window.navigator.sendBeacon(LOGE_URL_POST, JSON.stringify(data));
          if (status) {
            success();
          } else {
            fail(LOGE_URL_POST, data, ERROR.BEACON_FALSE);
          }
          return;
        }
        (0, _fetch.default)(LOGE_URL_POST, data, timeout, withCredentials, success, fail, '', encryption);
        return;
      }
    }
    (0, _fetch.default)(LOGE_URL_POST, data, timeout, withCredentials, success, fail, '', encryption);
  } catch (error) {
    (0, _fetch.default)(LOGE_URL_POST, data, timeout, withCredentials, success, fail, '', encryption);
  }
};
var _default = request;
exports.default = _default;